import { OnInit, Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core'
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UserApiService } from '../../api/user-api.service';
import { Usuario } from '../../../app/interface/Usuario.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.css']
})
export class UserAdminComponent implements OnInit, AfterViewInit { 
  @ViewChild('search',{ static:false }) search:ElementRef;

  usuarios:any[]=[]
  cerrar= false
  errorMessage:string=""
  buscar:string =""
  identificacion_edit
  nombres_edit
  apellidos_edit
  password_edit
  correo_empresarial_edit
  correo_personal_edit
  celular_edit
  telefono_edit
  direccion_edit
  fecha_nacimiento_edit
  genero_edit
  genero;
  id
  passwordNew:string = ""
  inputValue:FormGroup
  fecha_nacimiento_sin_editar
  page:number = 0
  generoEdit;
  correoPersonal:string=""
  correoCorporativo:string=""
  regex=/^\S+@\S+\.\S+$/
  regexIdentification = /^[0-9,$]*$/
  regexName =/^[a-zA-Z,ñ ]*$/
  regexPass =/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
  generos:any =[]
  p:number = 0
  regexTel = /^[0-9,+,-]*$/
  
  constructor(
      private user:UserApiService,
      private toastr:ToastrService,
      private fb:FormBuilder,
      private datepipe:DatePipe,
      private translate:TranslateService
   ) {

    this.inputValue = this.fb.group({
            documento : ["",[Validators.required, Validators.maxLength(20), Validators.pattern(this.regexIdentification)]],
            nombres: ["",[Validators.required, Validators.maxLength(80) , Validators.pattern(this.regexName) ]],
            apellidos: ["",[Validators.required, Validators.maxLength(40) , Validators.pattern(this.regexName)]],
            password: ["",[ Validators.minLength(6), Validators.maxLength(50), Validators.pattern(this.regexPass)]],
            correo_empresarial: ["",[Validators.maxLength(100),Validators.pattern(this.regex)]],
            correo_personal: ["",[Validators.maxLength(100),Validators.pattern(this.regex)]],
            celular: ["" ,[Validators.maxLength(20),Validators.pattern(this.regexTel)]],
            telefono: ["",[Validators.maxLength(20),Validators.pattern(this.regexTel)]],
            direccion: ["",[Validators.maxLength(150)]],
            fecha_nacimiento: [""],
            genero: [""],
            id:[""]
    })
   }
 
    ngOnInit() {
      this.user.getgenero().subscribe(resp => this.generos = resp)
    } 

    ngAfterViewInit() {
      
          const $search =  fromEvent(this.search.nativeElement,'keyup');
          $search.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            map( (e:any) => {
              if(e.target.value == ''){
                return
              }else{
                return e.target.value
              }
            }
            ),
            switchMap( data => this.user.searchUserData(data))
          ).subscribe(
            
            resp => {
              this.usuarios = resp.map( item =>{
                   const {fecha_nacimiento} = item
                    item.fecha_nacimiento = this.convertDate(fecha_nacimiento)
                    return item
              })
            
            }
          )
      
    }

    convertDate(item){
      const newDate = new Date(item)
      return newDate.setDate(newDate.getDate() + 1)
    }

    validateInput(field){
      return ( (!this.inputValue.get(field).valid && this.inputValue.get(field).touched) 
                ? 'is-invalid'
                :  this.inputValue.get(field).touched 
                ? 'is-valid':'')
    }

    cargarusuarios(){
      this.user.getUsuarios().subscribe(
        (data:any)=>{
        this.usuarios=data
      
        }
      
      )
    } 

    crearusuario(){
     const { password } = this.inputValue.value
      if(password === null){
           this.toastr.error(this.translate.instant('El campo password no puede quedar vacio')) 
           return 
      }
      this.user.crearUsuario(this.inputValue.value)
        .subscribe(()=>{
      
            this.inputValue.reset()
            this.cerrar= true
            this.toastr.success(this.translate.instant('usuario creado correctamente'))
            this.trash()
        },
          (err:any)=>{
            const { error } = err
            this.toastr.error(error.text)
          
          
          }
        )
    }

    editarusuario(){
  
     this.user.editarUsuario(this.inputValue.value).subscribe(
       ()=>{
         this.toastr.success(this.translate.instant('usuario editado correctamente') )
       },
       err => {
         this.toastr.error(err.error.text)
       }
     )
    
    }

    generoChange(input){
        this.generoEdit = input
    }

    editar(usuario){
       const data  = {
          bloqueo: usuario.bloqueo,
          celular:usuario.celular,
          correo_empresarial:usuario.correo_empresarial,
          correo_personal:usuario.correo_personal,
          creation_date:usuario.creation_date,
          deshabilitar:usuario.deshabilitar,
          direccion:usuario.direccion,
          documento:usuario.documento,
          fecha_nacimiento: this.datepipe.transform(usuario.fecha_nacimiento,'yyyy-MM-dd'),
          genero:usuario.genero,
          id:usuario.id,
          apellidos:usuario.user_name,
          id_genero:usuario.id_genero,
          password:usuario.password,
          telefono:usuario.telefono,
          nombres: usuario.user_name
       }

      this.inputValue.patchValue(data)

    }
    getOneData(id){

      this.user.getOneUser(id).subscribe(
         resp => this.usuarios = resp
      )
    }
 
    trash(){
      this.user.searchUserData(this.search.nativeElement.value).subscribe(
         resp =>{
          this.usuarios = []
         }
      )
     
    }
    change(event, id){
        this.user.bloqueo(id).subscribe(
          ( res ) => {
        
          }
        )
    }
    restablecer(usuario:Usuario){
      const { correo_empresarial, correo_personal } = usuario
      this.correoPersonal    = correo_personal
      this.correoCorporativo = correo_empresarial
    }
    correoP(){
    
      this.user.correoPersonal( this.correoPersonal)
        .subscribe(()=>{
          this.toastr.info(this.translate.instant('reseteo de password fue enviado'))
        },()=>{})
      
    }
    correoE(){
  
      this.user.correoCorporativo(this.correoCorporativo)
        .subscribe(()=>{
    
          this.toastr.info(this.translate.instant('reseteo de password fue enviado'))
        },()=>{})
    
    }
    eliminarusuario(id){
      let data = { id:id }

    Swal.fire({
        title: this.translate.instant('Estas Seguro?'),
        text:  this.translate.instant('Quieres eliminar el usuario'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#CC0F69',
        cancelButtonColor: '#6c757d',
        confirmButtonText: this.translate.instant('eliminar')
      }).then((result) => {
        if (result.isConfirmed) {
        this.user.eliminarusuario(data).subscribe(()=>{
          this.cargarusuarios();
          Swal.fire(
            this.translate.instant('Eliminado'),
             this.translate.instant('El usuario ha sido eliminado'),
            'success'
          )
           this.toastr.success(this.translate.instant('usuario eliminado'))
        },()=>{})
        }
      })

    }
    clean(){
      this.inputValue.reset() 
    }
  

}
